module.exports = __webpack_public_path__ + "static/media/summernote.54930463.ttf";